import { combineReducers } from 'redux';
import commonReducer from './commonReducer';
import getReducer from './getReducer';
import postReducer from './postReducer';
import classroomReducer from './classroomReducer';
import { experiences } from "../../portfolio_builder/src/components/Form/Experience/reducers";
import { educations } from "../../portfolio_builder/src/components/Form/Education/reducers";
import { awards } from "../../portfolio_builder/src/components/Form/Awards/reducers";
import { interests } from "../../portfolio_builder/src/components/Form/Interests/reducers";
import { skills } from "../../portfolio_builder/src/components/Form/Skills/reducers";
import { projects } from '../../portfolio_builder/src/components/Form/Project/reducer';
import { certification } from '../../portfolio_builder/src/components/Form/Certification/reducer';
const rootReducer = combineReducers({
  classroomReducer,
  commonReducer,
  getReducer,
  postReducer,
  experiences,
  educations,
  awards,
  interests,
  skills,
  projects,
  certification
});

export default rootReducer;
